import React from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import SubscriberContainer from '../../components/subscriber-container/subscriber-container.component'

const Tips = () => {
  return (
    <Switch>
      <Route path='/tips/subscriber/:id'>
        <SubscriberContainer />
      </Route>
    </Switch>
  )
}

export default Tips
